<template>
  <div>
    <slot></slot>

    <form @submit.prevent>
      <div class="mb3">
        <label for="caption" class="label block col-12 h6 left-align">NOTE</label>
        <textarea-autosize v-model="note.text" :min-height="30" rows="1" id="caption" class="input p1 col-12 border-box" autocorrect="off" spellcheck="false"></textarea-autosize>
      </div>

      <div class="mb3 relative">
        <label for="location" class="label block col-12 h6 left-align">LOCATION</label>
        <input :value="note.location" id="location" class="input p1 col-12" readonly style="font-size:11px">
        <span @click="changeLocation" class="absolute bottom-0 right-0 p1">
          <search-icon/>
        </span>
      </div>

      <!-- tags etc -->
      <taxonomies :lists="note.taxonomies"/>

      <div class="mb3 pb3 relative">
        <label @click="linking = true" for="projects" class="label block col-12 h6 left-align">LINKED PROJECT(S)</label>
        <div @keyup.space="linking = true" id="projects" tabindex="0" class="input p1 col-12 left-align h6">
          <span class="h6">{{ note.projects }}&ensp;</span><span @click="linking = true" class="pointer gray h6">✎&nbsp;&nbsp;Add</span>
        </div>
      </div>

      <div class="fixed left-0 bottom-0 right-0 flex p2 bg-white form-actions">
        <div class="h6 col-6 pr1">
          <button @click="saveDraft" class="btn btn-outline btn-rounded col-12">SAVE DRAFT</button>
        </div>
        <div class="h6 col-6 pl1">
          <button @click="upload" class="btn btn-rounded white bg-black col-12">UPLOAD</button>
        </div>
      </div>

      <!-- edit location -->
      <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
        <location-picker v-if="editingLocation" @close="editingLocation = null" @pick="updateLocation"/>
      </transition>

      <!-- link projects -->
      <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
        <linked-projects v-if="linking" @close="linking = false" @pick="linkProject" :list="note.linkedProjects"/>
      </transition>
    </form>
  </div>
</template>

<script>
  import Taxonomies from '@/components/Taxonomies'
  import LocationPicker from '@/components/LocationPicker'
  import LinkedProjects from '@/components/LinkedProjects'
  import Draft from '@/classes/Draft'
  import { formatLocation } from '@/util'

  export default {
    name: 'FieldNoteForm',
    props: {
      file: [File, Blob, Object],
      draft: Object,
      type: {
        type: String,
        default: 'note'
      }
    },
    data () {
      return {
        note: {},
        editingLocation: false,
        linking: false
      }
    },

    computed: {
      appCredentials () {
        return this.$store.state.appCredentials
      },

      userInfo () {
        return this.$store.state.userInfo
      }
    },

    created () {
      this.note = this.draft ? new Draft(this.draft.copy()) : new Draft()
      this.note.resourceType = this.type
      if (this.file) {
        this.note.setFile(this.file)
      }

      if (!this.note.hasLocation) {
        const deviceLoc = this.$store.state.location
        this.note.setLocation(deviceLoc)
      }
    },

    watch: {
      file (newVal) {
        if (newVal)  {
          this.note.setFile(newVal)
          this.note.createPreviewUrl()
        }
      }
    },

    methods: {
      saveDraft () {
        this.storeDraft().then(() => {
          this.$router.push('/mine?t=drafts')
        })
      },
      upload () {
        this.storeDraft().then(() => {
          // push to the upload queue
          this.$store.commit('ADD_UPLOAD', this.note.draftKey)
          this.$router.push('/mine?t=drafts')
        })
      },

      changeLocation () {
        this.editingLocation = true
      },

      updateLocation (geo) {
        if (!geo) {
          // use current
          const deviceLoc = this.$store.state.location
          this.note.setLocation(deviceLoc, true)
        } else {
          this.note.latitude = parseFloat(geo.lat)
          this.note.longitude = parseFloat(geo.lon)
          this.note.location = formatLocation(geo.address)
        }
      },

      linkProject (project) {
        this.note.addProject(project)
      },

      async storeDraft () {
        try {
          if (this.note.draftKey === null) {
            this.note.draftKey = new Date().getTime()
          }

          if (!this.note.previewUrl) {
            this.note.createPreviewUrl()
          }

          this.note.blobToFile()

          await this.$store.dispatch('storeDraft', {
            key: this.note.draftKey,
            data: this.note
          })

          this.$emit('close')
        } catch (err) {
          throw err
        }
      }
    },
    components: { Taxonomies, LocationPicker, LinkedProjects }
  }
</script>
